import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { VgHlsModule } from '../VgHls.Module';
import { SharedModule } from 'vbrick-player-src/shared/Shared.Module';

import { VgConferenceDualHlsService } from './VgConferenceDualHls.Service';
import { VgConferenceDualHlsComponent } from './VgConferenceDualHls.Component';
import { VbDualPlaybackLayoutMenuButtonComponent } from './VbDualPlaybackLayoutMenuButton.Component';
import { VbDualPlaybackLayoutMenuButtonV2Component } from './VbDualPlaybackLayoutMenuButtonV2.Component';

const components = [
	VgConferenceDualHlsComponent,
	VbDualPlaybackLayoutMenuButtonComponent,
	VbDualPlaybackLayoutMenuButtonV2Component
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		BsDropdownModule,
		CommonModule,
		VgHlsModule,
		SharedModule,
		TooltipModule
	],
	providers: [
		VgConferenceDualHlsService
	]
})
export class VgConferenceDualHlsModule {}
